import moment from 'moment';
import { DEFAULT_DATE_FORMAT } from '../constants/date';

export const dateFormat = (date, format = DEFAULT_DATE_FORMAT) => {
  if (!date) {
    return;
  }
  return moment(date).format(format);
};
